// extracted by mini-css-extract-plugin
export default {"termsContainer":"TermsNConditions_termsContainer__Ph7Oz","termsInnerContainer":"TermsNConditions_termsInnerContainer__4OPEt"};